export enum MortgageRequestType {
  Management = 'BEHEER',
  Acquisition = 'ACQUISITIE'
}
